<template>
  <section v-if="lang && lang['hotel_mobile_new']">
    <Title :title-name="pageTitle" :title-link="title.HotelList.titleLink" />
    <div v-if="!loading" class="hotel-list">
      <section>
        <div class="spinner-action" :class="{ 'spinner-active': spinner_active }">
          <div class="spinner-border text-dark icon-spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-if="!hasCancelHotelVoucher" class="container">
          <div class="my-4">
            <ItemOfVouchers icon="hotel-voucher" color="#f0725e" :label="lang['hotel_mobile_new'].SFS_LANG_ROW_1" border />
          </div>
          <div class="ws-textbox title-right-on-arabic">
            {{ lang['hotel_mobile_new'].SFS_LANG_ROW_14 }}
          </div>
          <div v-if="availableChangeMatrix" class="ws-textbox mt-4">
            <div class="change-room-allocation title-right-on-arabic" @click="changeRoomAllocation()">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_79 || 'Change Room allocation' }}
            </div>
          </div>
          <div class="mt-4">
            <div v-for="(hotel, index) in dataListHotel" :key="index" class="mb-4">
              <HotelCard :hotel-info="hotel" @handleBookHotel="handleBookHotel" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/HotelList.scss'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Title from '@/components/Title/index'
import { replaceStr } from '@/utils/helper'
import HotelCard from '@/components/HotelCard/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
const SORT_HOTEL_ESTIMATE_COST = 5

export default {
  name: 'HotelList',
  components: { Title, ItemOfVouchers, HotelCard },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sortDescription: false,
      publicPath: process.env.BASE_URL,
      hotelImageDefault: process.env.BASE_URL + 'images/No_Image_Available.jpg',
      loading: false,
      hasCancelHotelVoucher: false,
      validGGApi: true,
      curPaxInfo: null,
      numberRoomNeed: {},
      curNumberRoomNeed: null,
      storeTaxiOption: 0,
      spinner_active: false,
      availableChangeMatrix: false
    }
  },
  computed: {
    ...mapGetters({
      dataListHotel: 'HotelList/dataListHotel',
      isInventoryList: 'HotelList/isInventoryList',
      services: 'HotelList/services',
      voucherHotel: 'SelectRoom/PaxsHotel',
      OverNightStation: 'Home/OverNightStation'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    }
  },
  watch: {
    PaxsGroup: function () {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.airline)) {
        this.initData()
      }
    },
    pax: function () {
      if (!_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.airline)) {
        this.initData()
      }
    },
    airline: function () {
      if (!_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.pax)) {
        this.initData()
      }
    },
    dataListHotel: function () {
      if (_.size(this.dataListHotel) == 0) {
        this.$router.push({ path: '/no-hotels-available', query: { secret: this.secret } })
        return
      } else if (this.airline.params.default_sort_order && this.airline.params.default_sort_order == SORT_HOTEL_ESTIMATE_COST) {
        let self = this
        _.each(self.dataListHotel, function (hotel) {
          self.processParamTaxi({}, hotel).then((payload) => {
            hotel.taxi_cost =
              payload.assignTaxiParams && payload.assignTaxiParams.total_price ? payload.assignTaxiParams.total_price : 0
            if (hotel.distance_in_km > 0) {
              hotel.total_estimate_cost = parseFloat((hotel.taxi_cost + hotel.total).toFixed(2))
            } else {
              hotel.total_estimate_cost = parseFloat(hotel.total.toFixed(2))
            }
          })
        })
      }
    }
  },
  created() {
    this.loading = true

    this.$store.dispatch('reGetPax')

    if (!_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.airline) && !_.isEmpty(this.pax)) {
      this.initData()
    }
  },
  methods: {
    replaceStr,
    imgDefault(event) {
      event.target.src = this.hotelImageDefault
    },
    initData() {
      var self = this
      let reservationId = this.$route.query.reservation_id
      let voucherId = this.$route.query.voucher_id

      self.$store.dispatch('Home/getOverNightStation')
      self.$store
        .dispatch('SelectRoom/getVoucherHotel', {
          passenger_id: [self.pax.id],
          reservation_id: reservationId,
          voucher_id: voucherId
        })
        .then(function () {
          self.loading = false
          if (self.pax.has_cancelled_hotel_voucher && _.isEmpty(self.voucherHotel)) {
            // Has cancelled hotel voucher
            self.hasCancelHotelVoucher = true
            let lang = self.lang
            const cancelMessage =
              lang['hotel_mobile_new'].SFS_LANG_ROW_25 ||
              'We are sorry the room was cancelled. For further assistance, please contact the service desk.'
            self.$swal(cancelMessage).then(() => {
              self.$router.replace({ name: 'Home', query: { secret: self.secret } })
            })
            return
          }

          if (
            self.PaxsGroup.length > 1 &&
            (_.isUndefined(self.pax.curPaxID) || _.isNull(self.pax.curPaxID) || self.pax.curPaxID == '') &&
            self.$route.name != 'PaxContactConfirm'
          ) {
            // Group more than 2 persons and don't know who are you
            self.$router.push({ path: '/pax-contact-confirm', query: { secret: self.secret } })
            return
          }
          // Get Hotel voucher & check existing
          self.$store.dispatch('Taxi/getTaxi').then((response) => {
            if (_.size(response)) {
              // Voucher exists
              self.$router.push({
                path: '/select-room',
                query: {
                  secret: self.secret,
                  pax_voucher_id: response.passenger_id,
                  reservation_id: reservationId,
                  voucher_id: voucherId
                }
              })
              return
            }
            // No voucher exists
            // Fetch hotel services info
            self.$store.dispatch('HotelList/getServices').then((services) => {
              let dataHotel = services[1]
              if (_.isUndefined(dataHotel)) {
                self.$router.push({ name: 'Home', query: { secret: self.secret } })
                return
              }
              if (typeof services[4] !== 'undefined') {
                if (typeof services[4].store_taxi_option !== 'undefined') {
                  self.storeTaxiOption = services[4].store_taxi_option === null ? 0 : services[4].store_taxi_option
                }
              }

              if (self.PaxsGroup.length == 1) {
                // Single passenger
                self.fetchListHotel(dataHotel)
              } else {
                if (self.dataListHotel.length) {
                  self.getARoomNeed(dataHotel)
                  return
                }
                // Group with more than 1 passenger
                if (!_.isNull(dataHotel.params) && !_.isUndefined(dataHotel.params.matrix_share_room)) {
                  // Matrix existed
                  self.fetchListHotel(dataHotel)
                  return
                }
                self.$router.push({ path: '/hotel-book', query: { secret: self.secret } })
              }
            })
          })
        })
      if (!_.isEmpty(this.airline)) {
        // this function will be call when fail to authenticate gg api
        window.gm_authFailure = function () {
          self.validGGApi = false
        }
      }

      // Get current passenger info
      self.curPaxInfo = self.pax
      if (self.PaxsGroup.length > 1) {
        self.curPaxInfo = _.find(self.PaxsGroup, { passenger_id: parseInt(self.pax.curPaxID) })
        self.availableChangeMatrix = true
      }
    },
    renderLockShareRoom(payload, reservation) {
      let paxsGroup = this.PaxsGroup
      let roomNeed = this.curNumberRoomNeed
      let room_available = {
        s: reservation.s_room,
        d: reservation.sd_room,
        t: reservation.t_room,
        q: reservation.q_room
      }
      let selRoom = {
        single: !_.isUndefined(roomNeed.s_room) ? roomNeed.s_room : 0,
        double: !_.isUndefined(roomNeed.sd_room) ? roomNeed.sd_room : 0,
        triple: !_.isUndefined(roomNeed.t_room) ? roomNeed.t_room : 0,
        quad: !_.isUndefined(roomNeed.q_room) ? roomNeed.q_room : 0
      }

      let share_room = { single: 0, double: 0, tripple: 0, quad: 0 }

      if (!_.isUndefined(room_available) && !_.isEmpty(room_available)) {
        if (selRoom.single > room_available.s) {
          selRoom.double = selRoom.double + (selRoom.single - room_available.s)
          selRoom.single = room_available.s
          console.log('The case 1')
        } else if (paxsGroup.length == 1 && selRoom.single == 0 && room_available.s_room > 0) {
          // The case on click change [Select] selectReservation of hotel
          selRoom.single = 1
          selRoom.double = 0
          console.log('The case 2')
        }
        share_room.single = selRoom.single
        if (selRoom.double > room_available.d) {
          selRoom.triple = selRoom.triple + (selRoom.double - room_available.d)
          selRoom.double = room_available.d
          console.log('The case 3')
        } else if (paxsGroup.length == 2 && selRoom.double == 0 && room_available.d > 0) {
          // The case on click change [Select] selectReservation of hotel
          selRoom.double = 1
          selRoom.triple = 0
          console.log('The case 4')
        }
        share_room.double = selRoom.double
        if (selRoom.triple > room_available.t) {
          selRoom.quad = selRoom.quad + (selRoom.triple - room_available.t)
          selRoom.triple = room_available.t
          console.log('The case 5')
        } else if (paxsGroup.length == 3 && selRoom.triple == 0 && room_available.t > 0) {
          // The case on click change [Select] selectReservation of hotel
          selRoom.triple = 1
          selRoom.quad = 0
          console.log('The case 6')
        }
        share_room.tripple = selRoom.triple
        if (selRoom.quad < room_available.q) {
          share_room.quad = selRoom.quad
          console.log('The case 7')
        }
      }
      payload.s_room = share_room.single
      payload.sd_room = share_room.double
      payload.t_room = share_room.tripple
      payload.q_room = share_room.quad
      return payload
    },
    fetchListHotel(dataHotel) {
      var self = this
      let dataSearchHotel = self.getARoomNeed(dataHotel)
      this.$store.dispatch('HotelList/updateListHotel', dataSearchHotel)
      // this.handlePaxShareRoom(dataHotel)
    },
    handleBookHotel(hotel) {
      var self = this
      self.spinner_active = true
      let payload = {}
      if (hotel.reservations) {
        // Book reservation
        payload = self.renderLockShareRoom(payload, hotel.reservations[0])
        payload.date = moment(self.pax.flight_date).format('YYYY-MM-DD')
        payload.secret = self.secret
        payload.room_id = hotel.reservations[0].room_id
        payload.hotel_id = hotel.hotel_id
        payload.reservations = _.map(hotel.reservations, function (o) {
          return {
            id: o.id,
            selected_mealplan: false,
            selected_lunch: false,
            selected_breakfast: false
          }
        })
      } else {
        // Book partner
        payload.date = moment(self.pax.flight_date).format('YYYY-MM-DD')
        payload.secret = self.secret
        payload.room_id = hotel.id
        payload.hotel_id = hotel.hotel_id
      }
      payload.self_service = hotel.self_service
      payload.is_inventory = this.isInventoryList
      // Make params auto assign taxi when hotel has auto assign taxi, and has only one taxi company
      self.processParamTaxi(payload, hotel).then((payload) => {
        payload.language = self.checkLanguage()
        payload.hotel_list_page = true
        self.$store.dispatch('HotelList/bookListHotel', payload).then((res) => {
          // if passenger had voucher -> redirect to home
          if (res?.has_voucher === true) {
            self.$router.push({ path: '/', query: { secret: self.secret } })
            return
          }

          if (typeof res.is_research_hotel !== 'undefined' && res.is_research_hotel === true) {
            self.spinner_active = false
            window.location.href = '/hotel-list?secret=' + this.secret
            return
          }

          if (res.success) {
            self.spinner_active = false
            // Set voucher_id for PaxsGroup
            let resBookHotel
            _.each(res.data, function (data) {
              // Response data from book hotel partner and book reservation is different
              data = !_.isUndefined(data[0]) ? data : [data]
              resBookHotel = _.first(data)
              _.each(self.PaxsGroup, function (pax) {
                if (
                  _.some(resBookHotel.passengers, function (e) {
                    // Check element in array exists
                    // equivalent with includes (lodash) and contains (underscore) but don't care about data type
                    return e == pax.passenger_id
                  })
                ) {
                  pax.voucher_id = resBookHotel.voucher_id
                }
              })
            })
            // If total passengers > number pax per taxi, we will be redirected to matrix taxi page
            let routeName = 'SelectRoom'
            const paxPerTaxi = this.airline.params.pax_per_taxi
            const totalPassengers = res.data.reduce((total, data) => total + data.passengers.length, 0)
            if (
              totalPassengers > paxPerTaxi &&
              resBookHotel &&
              !res.hasOwnProperty('is_stored_option_taxi') &&
              _.includes([2, 3, 5], _.get(resBookHotel, 'transport_id', []))
            ) {
              //if book by group, redirect to matrix page
              routeName = 'TaxiService' //2 airport to hotel, 3 two ways, 5 hotel to airport
            }
            let paxs_group = _.filter(self.PaxsGroup, function (pax) {
              return !self.isInfant(pax)
            })
            let pax_id = paxs_group[0].passenger_id
            self.$router.push({ name: routeName, query: { secret: self.secret, pax_voucher_id: pax_id } }) // Hotel voucher
            return
          }

          self.spinner_active = false
          self.$router.push({ path: '/no-hotels-available', query: { secret: self.secret, has_booked_failed: 1 } })
        })
      })
    },
    changeRoomAllocation() {
      this.$router.push({ path: '/hotel-book', query: { secret: this.secret } })
    },
    getARoomNeed(dataHotel) {
      let dataSearchHotel = {
        flight_date: moment(this.pax.flight_date).format('YYYY-MM-DD'),
        secret: this.secret,
        lang_code: this.lang.lang_code,
        aRoomNeed: {
          s_room: 0,
          sd_room: 0,
          t_room: 0,
          q_room: 0
        }
      }
      if (this.PaxsGroup.length == 1) {
        dataSearchHotel.aRoomNeed.s_room++
      } else if (dataHotel.params != null && typeof dataHotel.params.matrix_share_room !== 'undefined') {
        let maxtrix_share_room = dataHotel.params.matrix_share_room.filter((room) => {
          return room.isInfant != 'true'
        })
        let listPaxs = _.groupBy(maxtrix_share_room, function (o) {
          return o.room
        })
        _.each(listPaxs, function (t) {
          // Remove INFT
          _.remove(t, function (p) {
            return p.isInfant == true
          })
          switch (t.length) {
            case 1:
              dataSearchHotel.aRoomNeed.s_room++
              break
            case 2:
              dataSearchHotel.aRoomNeed.sd_room++
              break
            case 3:
              dataSearchHotel.aRoomNeed.t_room++
              break
            case 4:
              dataSearchHotel.aRoomNeed.q_room++
              break
            default:
              break
          }
        })
      } else {
        dataSearchHotel.aRoomNeed.s_room = this.PaxsGroup.length
      }
      this.numberRoomNeed = dataSearchHotel.aRoomNeed
      this.curNumberRoomNeed = this.numberRoomNeed
      return dataSearchHotel
    },
    async processParamTaxi(payload, hotel) {
      // Check whether enable auto assign taxi then make params for it
      var self = this
      let overnight_station = self.OverNightStation
      let storeTaxiOption = self.storeTaxiOption
      let transportId = hotel.additional_transport_id
      let distanceHotel = hotel.road_distance_airport || 0

      switch (storeTaxiOption) {
        // One way to hotel
        case 1:
          transportId = 2
          break
        // Two way to hotel <--> airport
        case 2:
          transportId = 3
          break
        // One way to airport
        case 3:
          transportId = 5
          break
      }

      if (_.includes([2, 3, 5], transportId)) {
        // Calculate distance by gg map api
        let origins = []
        let destinations = []
        let paxIds = _.map(self.PaxsGroup, (pax) => pax.passenger_id)
        payload.assignTaxiParams = {
          hotel_id: payload.hotel_id,
          passenger: paxIds,
          date: payload.date,
          transport_id: transportId,
          airline_id: self.airline.airline_id,
          airport_code: !_.isEmpty(overnight_station) ? overnight_station.code : self.airline.airport_code,
          airport_id: !_.isEmpty(overnight_station) ? overnight_station.id : self.airline.airport_id,
          is_auto_taxi: true
        }
        switch (transportId) {
          case 2:
            // Airport -> Hotel
            payload.assignTaxiParams.option_taxi = 1
            payload.assignTaxiParams.way_option = 1
            payload.assignTaxiParams.from_address = !_.isEmpty(overnight_station)
              ? overnight_station.name
              : self.airline.airport_name
            payload.assignTaxiParams.to_address = hotel.address
            origins = [
              !_.isEmpty(overnight_station)
                ? `${overnight_station.geo_lat}, ${overnight_station.geo_lon}`
                : `${self.airline.geo_lat}, ${self.airline.geo_lon}`
            ]
            destinations = [`${hotel.geo_location_latitude}, ${hotel.geo_location_longitude}`]
            break
          case 5:
            // Hotel -> Airport
            payload.assignTaxiParams.option_taxi = 3
            payload.assignTaxiParams.way_option = 1
            payload.assignTaxiParams.from_address = hotel.address
            payload.assignTaxiParams.to_address = !_.isEmpty(overnight_station)
              ? overnight_station.name
              : self.airline.airport_name
            origins = [`${hotel.geo_location_latitude}, ${hotel.geo_location_longitude}`]
            destinations = [
              !_.isEmpty(overnight_station)
                ? `${overnight_station.geo_lat},${overnight_station.geo_lon}`
                : `${self.airline.geo_lat}, ${self.airline.geo_lon}`
            ]
            break
          case 3:
            // 2 way
            payload.assignTaxiParams.option_taxi = 2
            payload.assignTaxiParams.way_option = 2
            payload.assignTaxiParams.from_address = !_.isEmpty(overnight_station)
              ? overnight_station.name
              : self.airline.airport_name
            payload.assignTaxiParams.to_address = hotel.address
            origins = [
              !_.isEmpty(overnight_station)
                ? `${overnight_station.geo_lat},${overnight_station.geo_lon}`
                : `${self.airline.geo_lat}, ${self.airline.geo_lon}`,
              `${hotel.geo_location_latitude}, ${hotel.geo_location_longitude}`
            ]
            destinations = [
              `${hotel.geo_location_latitude}, ${hotel.geo_location_longitude}`,
              !_.isEmpty(overnight_station)
                ? `${overnight_station.geo_lat},${overnight_station.geo_lon}`
                : `${self.airline.geo_lat}, ${self.airline.geo_lon}`
            ]
            break
        }

        let maximum_walking_distance =
          this.airline.airport_config_distance || this.airline.params.airline_config_taxi.maximum_walking_distance
        let taxiConfig = this.airline.params.airline_config_taxi
        let taxiAirportConfig = overnight_station.airline_airport_detail
        let km_rate_airline = Number(taxiConfig.km_rate) !== 0 ? taxiConfig.km_rate : 3
        let starting_tariff_airline = Number(taxiConfig.starting_tariff) !== 0 ? taxiConfig.starting_tariff : 0
        let km_rate =
          !_.isEmpty(taxiAirportConfig.km_rate) && Number(taxiAirportConfig.km_rate) !== 0
            ? taxiAirportConfig.km_rate
            : km_rate_airline
        let starting_tariff =
          !_.isEmpty(taxiAirportConfig.starting_tariff) && Number(taxiAirportConfig.starting_tariff)
            ? taxiAirportConfig.starting_tariff
            : starting_tariff_airline
        let airline_taxi_fee = this.airline && this.airline.taxi_fee ? this.airline.taxi_fee : 0
        let waiting_tarif =
          this.airline && this.airline.params && this.airline.params.taxi_waiting_tarif
            ? this.airline.params.taxi_waiting_tarif
            : 10
        let distance = distanceHotel * payload.assignTaxiParams.way_option
        let distanceOneWay = distanceHotel
        let distance2Way = 0
        if (self.validGGApi) {
          let locationRequest = {
            origins: origins,
            destinations: destinations,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false
          }
          let response = await self.getDistanceMatrix(locationRequest)
          if (response) {
            let rows = response.rows
            let distanceGoogle = null
            // Calculate way 1
            if (rows[0] && rows[0].elements[0].status == 'OK') {
              distanceGoogle = distanceOneWay = rows[0].elements[0].distance.value / 1000
            }

            distance = distanceGoogle ?? distance
            // Calculate way 2 if exist. And make sure way 1 is OK by variable distance
            if (rows[1] && rows[1].elements[1].status == 'OK' && distance) {
              distance2Way = rows[1].elements[1].distance.value / 1000

              payload.assignTaxiParams.price_airport_to_hotel =
                parseFloat(km_rate) * parseFloat(distance.toFixed(2)) + parseFloat(starting_tariff)
              payload.assignTaxiParams.distance_airport_to_hotel = distance

              payload.assignTaxiParams.price_hotel_to_airport =
                parseFloat(km_rate) * parseFloat(distance2Way.toFixed(2)) + parseFloat(starting_tariff)
              payload.assignTaxiParams.distance_hotel_to_airport = distance2Way
            }
          }
        }
        let priceTaxi = parseFloat(km_rate) * parseFloat(distance.toFixed(2)) + parseFloat(starting_tariff)
        if (distance2Way) {
          priceTaxi += parseFloat(km_rate) * parseFloat(distance2Way.toFixed(2)) + parseFloat(starting_tariff)
        }
        payload.assignTaxiParams.distance = distanceOneWay
        payload.assignTaxiParams.total_price = priceTaxi
        payload.isAutoAssignTaxi = priceTaxi && distanceHotel * 1000 > maximum_walking_distance ? true : false
      }

      return payload
    },
    getDistanceMatrix(data) {
      // Make promise of get distance gg api in order to waiting finish calculate distance taxi then book
      var service = new google.maps.DistanceMatrixService()
      return new Promise((resolve, reject) => {
        service.getDistanceMatrix(data, (response, status) => {
          resolve(response)
        })
      })
    },
    isInfant(pax) {
      let ssrs = pax.ssrs
      if (!_.isUndefined(ssrs) && pax.invoicing_flag == 'INFT') {
        let invoicing_flag = _.find(ssrs, function (ssr) {
          return ssr.type == 'INFT'
        })
        if (!invoicing_flag) {
          //define ssr object via amadeus
          let infant = {
            type: 'INFT',
            key: '#INFT',
            ssrValue: {}
          }
          ssrs.push(infant)
        }
      }
      let result = _.find(ssrs, function (ssr) {
        return ssr.type == 'INFT'
      })
      if (result) {
        return true
      } else {
        return false
      }
    },
    checkLanguage() {
      let langCode = _.first(this.PaxsGroup).language
      if (_.size(this.PaxsGroup) > 1) {
        let checkLang = _.find(this.PaxsGroup, function (o) {
          return o.language.toLowerCase() != langCode.toLowerCase()
        })
        if (!_.isEmpty(checkLang)) {
          langCode = 'en'
        }
      }
      return langCode
    }
  }
}
</script>
